/**
 * FullPageSkeleton — full-viewport centred loading indicator.
 *
 * Displayed by AuthGuard / GuestGuard while the /me/ query is in flight,
 * so the user never sees an abrupt redirect before auth status is resolved.
 */
import { Box, CircularProgress } from '@mui/material';

export function FullPageSkeleton() {
  return (
    <Box
      aria-label="Chargement…"
      data-testid="full-page-skeleton"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100dvh',
        bgcolor: 'background.default',
      }}
    >
      <CircularProgress
        size={48}
        thickness={4}
        sx={{ color: 'primary.main' }}
      />
    </Box>
  );
}

export default FullPageSkeleton;
